import {Component, OnInit} from '@angular/core';
import {OverlayConfig, OverlayRef} from "exc-controls";
import {ExcTranslation} from "exc-core";

@Component({
  selector: 'app-modal-assign-reviews',
  templateUrl: './modal-assign-reviews.component.html',
  styles: []
})
export class ModalAssignReviewsComponent extends ExcTranslation implements OnInit {
  remarks = '';
  reviewEditors = [];
  selectedEditor = null;
  previewMode: boolean;

  constructor(private overlayRef: OverlayRef, private overlayConfig: OverlayConfig) {
    super();
    this.previewMode = overlayConfig.data.previewMode;
  }

  ngOnInit() {
    this.reviewEditors = [{EditorID: '-', EditorName: '-'}, ...this.overlayConfig.data.reviewEditors];
  }
}
